import { ElementRef, NgModule } from '@angular/core';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { GridModule, PDFModule } from '@progress/kendo-angular-grid';
import { SVGIconModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { MessageService, RTL } from '@progress/kendo-angular-l10n';
import { LabelModule } from '@progress/kendo-angular-label';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { NavigationModule } from '@progress/kendo-angular-navigation';
import { NOTIFICATION_CONTAINER, NotificationModule } from '@progress/kendo-angular-notification';
import { PopupModule } from '@progress/kendo-angular-popup';
import { RippleModule } from '@progress/kendo-angular-ripple';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { TooltipsModule } from '@progress/kendo-angular-tooltip';
import { UploadsModule } from '@progress/kendo-angular-upload';
import { CustomKendoMessageService } from 'src/app/services/custom-kendo-message.service';

export function kendoComponentsDirection() {
  /* kendo does not support factory method that returns a promise
  return firstValueFrom(settings$.pipe(filter(settings => !!settings), map(settings => AppSettings.isRtlLanguage(settings.language)), tap(data => console.log('@data', data)))); */

  return document.dir == 'rtl'; // works but requires a refresh to the page for the breadcrumb to update direction
}

export function services() {
  return [
    {
      provide: MessageService,
      /* must use 'useExisting' instead of 'useClass' because otherwise CustomKendoMessageService will be instantiated mutiple times
         causing redundant subscriptions on translate.onLangChange, set @Injectable({ providedIn: 'root' }) as well  */
      useExisting: CustomKendoMessageService,
    },
    {
      // must set RTL otherwise breadcrumb won't change direction
      provide: RTL,
      useFactory: kendoComponentsDirection,
    },
    {
      provide: NOTIFICATION_CONTAINER,
      useFactory: () => {
        return { nativeElement: document.body } as ElementRef;
      },
    },
  ];
}

const kendoModules = [
  IndicatorsModule,
  NotificationModule,
  GridModule,
  PDFModule,
  ButtonsModule,
  NavigationModule,
  InputsModule,
  LabelModule,
  DateInputsModule,
  PopupModule,
  DropDownsModule,
  DialogsModule,
  ToolBarModule,
  LayoutModule,
  SVGIconModule,
  RippleModule,
  UploadsModule,
  TooltipsModule,
];

@NgModule({
  imports: [...kendoModules],
  exports: [...kendoModules],
  providers: [...services()],
})
export class KendoModule {}
